import React from "react";
import './Footer.css';

const Footer = () => (
  <footer className="App-footer">
    <a href="/oss-licenses.html" target="_blank" rel="noopener noreferrer">
      ライセンス
    </a>
    <p>&copy; Euphoria Co., Ltd. All Rights Reserved.</p>
  </footer>
);

export default Footer;
